define('collection/StateCollection',['require','lib/collection/BaseCollection','model/CountryModel'],function (require) {

    var BaseCollection = require('lib/collection/BaseCollection');
    var StateModel = require('model/CountryModel');

    /**
     * State list collection
     *
     * @class StateCollection
     */
    var StateCollection = BaseCollection.extend({

        url: '/state/',
        model: StateModel

    });

    StateCollection._instance = null;
    StateCollection.getInstance = function () {
        if (!StateCollection._instance) {
            StateCollection._instance = new StateCollection();
        }
        return StateCollection._instance;
    };

    return StateCollection;

});
